import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router'
import { Icon, type IconName } from '@/components/Icon'

/**
 * The sections. Only BUILT sections appear: an unbuilt one is hidden, never
 * shown disabled (CREW, JOBS, INTEL and STORE arrive with their screens).
 */
const SECTIONS: { to: string; key: 'map' | 'empire'; icon: IconName }[] = [
  { to: '/map', key: 'map', icon: 'map' },
  { to: '/empire/property', key: 'empire', icon: 'empire' },
]

export function LeftRail() {
  const { t } = useTranslation()
  return (
    <nav aria-label={t('shell.sections')} className="flex w-[76px] shrink-0 flex-col items-stretch border-r border-border bg-bg-deep py-3">
      {SECTIONS.map((s) => (
        <NavLink
          key={s.key}
          to={s.to}
          className={({ isActive }) =>
            `relative flex flex-col items-center gap-1.5 py-3.5 transition-colors ${
              isActive ? 'bg-crimson-wash text-ink' : 'text-ink-mute hover:bg-panel hover:text-ink-soft'
            }`
          }
        >
          {({ isActive }) => (
            <>
              {isActive && <span aria-hidden className="absolute inset-y-0 left-0 w-[3px] bg-crimson" />}
              <Icon name={s.icon} size={22} />
              <span className="font-title text-[10px] tracking-[0.24em] uppercase">{t(`nav.${s.key}`)}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
